export default __webpack_public_path__ + "assets/icons/home_yunfeishixiaochaxun.7594e85e.svg";